<template>
  <!-- 粮虫汇总数据 -->
  <div class="bg-white p-x-15 p-b-15" style="padding-top: 0px; height: 100%;">
    <tk-flex middle center class="w-full text-center" style="height: 60px; font-weight: 600;font-size:16px;">
      粮虫汇总数据
    </tk-flex>
    <a-table :dataSource="dataSource" :columns="columns" bordered :pagination="false" size="small"/>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    dataSource: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    }
  }
}
</script>

<style>
</style>
